import Vue from "vue";
import vuetify from "./plugins/vuetify";
import VueRouter from "vue-router";
import App from "./App.vue";
import firebase from "firebase/app";
import store from "./store";
import routes from "./routes/routes";
import "firebase/auth";
import "firebase/firestore";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import LightBootstrap from "./light-bootstrap-main";
import "./registerServiceWorker";
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import vSelect from 'vue-select';
import '@trevoreyre/autocomplete-vue/dist/style.css'
import Autocomplete from '@trevoreyre/autocomplete-vue';
import JwPagination from 'jw-vue-pagination';
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;


const firebaseConfig = {
  apiKey: "AIzaSyAqCHMVSBpt2uwjA51MoJli5tAMR-3FAAk",
  authDomain: "weni-281323.firebaseapp.com",
  databaseURL: "https://weni-281323.firebaseio.com",
  projectId: "weni-281323",
  storageBucket: "weni-281323.appspot.com",
  messagingSenderId: "998916196846",
  appId: "1:998916196846:web:e2a21eb1b05c3c4e5d26ff",
  measurementId: "G-SNDMZS45TQ",
};
firebase.initializeApp(firebaseConfig);

const db = firebase.database();
const dbstore = firebase.firestore();
const auth = firebase.auth();
const fbfunctions = firebase.functions();

Vue.component('jw-pagination', JwPagination);
Vue.use(firebase);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.component('v-select', vSelect)
UIkit.use(Icons);
Vue.use(Autocomplete)


const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  mode: "history",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

firebase.auth().onAuthStateChanged((user) => {
     if(user){
      dbstore.collection('users').doc(user.uid).
      onSnapshot(function (doc) {
        store.dispatch("fetchUser", {
          id: user.uid,
          email: user.email,
          name: user.displayName,
          role:  doc.data().role
        });
      });
     }
});

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
};

router.beforeEach(async (to, from, next) => {
  const authRequired = to.matched.some((record) => record.meta.authRequired);
  if (authRequired && !(await firebase.getCurrentUser())) {
    next("/login");
  } else {
    next();
  }
});
new Vue({
  vuetify,
  router,
  store,
  firebase: firebase,
  render: (h) => h(App),
  data: {
    count: 0,
  },
}).$mount("#app");

export { db, dbstore, auth, fbfunctions};
